export default "__VITE_ASSET__DJkWb8HN__"